import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=2cfdb9fa&"
import script from "./Payments.vue?vue&type=script&lang=js&"
export * from "./Payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports